/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import http from '../../services/http';
import httpPhp from '../../services/httpPhp';
import Loader from '../loader/loader';
import authActions from '../../actions/auth/auth';
import store from '../../store';

import './loginForm.less';

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      errors: {},
      loading: false,
      deviceToken: null,
    };

    store.subscribe(() => {
      this.setState({
        deviceToken: store.getState().auth.deviceToken,
      });
    });
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;

    let response;

    try {
      response = await http.post('/api/auth/login', values);
      this.setState({ loading: false });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console

      this.setState({ loading: false });

      const errorMessage = error.errorMessage || 'Nie udało się zalogować!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return null;
    }


    const { history, loginSuccess } = this.props;


    loginSuccess(response);

    try {
      if (response.access_token) {
        await this.sendMobileDeviceToken(response.access_token);
      }
    } catch (error) {
      console.error(error);
    }

    return history.replace('/create-order');
  }

  sendMobileDeviceToken = async () => {
    const { deviceToken } = this.state;
    if (deviceToken != null) {
      const data = {
        deviceToken,
      };
      await httpPhp.post('/api/users/update-mobile-device-token', data);
    }
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const { loading } = this.state;
    const { history } = this.props;

    return (
      <form className="login-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            {this.renderField('UserName', 'Login (e-mail)', { required: true, type: 'email' })}
          </Grid>
          <Grid item xs={12}>
            {this.renderField('Password', 'Hasło', { required: true, type: 'password' })}
          </Grid>
        </Grid>

        <div className="remind-password-button-container">
          <Button size="large" color="primary" onClick={() => history.push('/reset-password-request')}>
            Nie pamiętam hasła
          </Button>
        </div>

        <div className="send-button-container">
          <Button size="large" variant="contained" color="primary" type="submit">
            Zaloguj
          </Button>
        </div>
      </form>
    );
  }
}

RegistrationForm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
    push: PropTypes.func,
  }).isRequired,
  loginSuccess: PropTypes.func.isRequired,
};

const bindActions = {
  loginSuccess: authActions.loginSuccess,
};

export default connect(
  null,
  bindActions,
)(
  withRouter(RegistrationForm),
);
